import React, { useState } from 'react';
import './MateriaisDidaticos.css';

const MateriaisDidaticos = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('grid');

  const categories = [
    { id: 'all', label: 'Todos os Materiais', icon: '📚', count: 48 },
    { id: 'apostilas', label: 'Apostilas', icon: '📖', count: 12 },
    { id: 'videos', label: 'Vídeos', icon: '🎥', count: 8 },
    { id: 'exercicios', label: 'Exercícios', icon: '✏️', count: 15 },
    { id: 'jogos', label: 'Jogos Educativos', icon: '🎮', count: 6 },
    { id: 'projetos', label: 'Projetos', icon: '📋', count: 7 }
  ];

  const materials = [
    {
      id: 1,
      title: 'Apostila de Matemática - 9º Ano',
      category: 'apostilas',
      subject: 'Matemática',
      description: 'Conteúdo completo de matemática para o 9º ano, incluindo equações, geometria e estatística.',
      type: 'PDF',
      size: '15.2 MB',
      pages: 120,
      downloadUrl: '#',
      thumbnail: '📚',
      tags: ['equações', 'geometria', 'estatística'],
      rating: 4.8,
      downloads: 234,
      dateAdded: '2026-01-15'
    },
    {
      id: 2,
      title: 'Vídeo Aula - Revolução Industrial',
      category: 'videos',
      subject: 'História',
      description: 'Animação explicativa sobre a Revolução Industrial e seus impactos sociais.',
      type: 'MP4',
      size: '125.8 MB',
      duration: '15:30',
      downloadUrl: '#',
      thumbnail: '🎥',
      tags: ['revolução industrial', 'história', 'sociedade'],
      rating: 4.9,
      downloads: 189,
      dateAdded: '2026-01-20'
    },
    {
      id: 3,
      title: 'Jogo - Batalha de Equações',
      category: 'jogos',
      subject: 'Matemática',
      description: 'Jogo educativo para praticar resolução de equações de forma divertida.',
      type: 'HTML5',
      size: '2.1 MB',
      levels: 10,
      downloadUrl: '#',
      thumbnail: '🎮',
      tags: ['equações', 'jogo', 'prática'],
      rating: 4.7,
      downloads: 156,
      dateAdded: '2026-01-18'
    },
    {
      id: 4,
      title: 'Ficha de Exercícios - Português',
      category: 'exercicios',
      subject: 'Português',
      description: 'Exercícios variados de gramática e interpretação de texto.',
      type: 'PDF',
      size: '3.5 MB',
      pages: 8,
      downloadUrl: '#',
      thumbnail: '✏️',
      tags: ['gramática', 'interpretação', 'exercícios'],
      rating: 4.6,
      downloads: 298,
      dateAdded: '2026-01-10'
    },
    {
      id: 5,
      title: 'Projeto - Feira de Ciências',
      category: 'projetos',
      subject: 'Ciências',
      description: 'Guia completo para organizar uma feira de ciências na escola.',
      type: 'PDF',
      size: '8.7 MB',
      pages: 45,
      downloadUrl: '#',
      thumbnail: '🔬',
      tags: ['ciências', 'projeto', 'feira'],
      rating: 4.9,
      downloads: 87,
      dateAdded: '2026-01-22'
    },
    {
      id: 6,
      title: 'Apostila Interativa - Ciências',
      category: 'apostilas',
      subject: 'Ciências',
      description: 'Apostila digital com animações e exercícios interativos.',
      type: 'HTML5',
      size: '45.2 MB',
      pages: 80,
      downloadUrl: '#',
      thumbnail: '🔬',
      tags: ['interativo', 'ciências', 'animado'],
      rating: 5.0,
      downloads: 312,
      dateAdded: '2026-01-25'
    },
    {
      id: 7,
      title: 'Coleção de Mapas Históricos',
      category: 'apostilas',
      subject: 'História',
      description: 'Conjunto de mapas históricos do Brasil e do mundo.',
      type: 'PDF',
      size: '22.1 MB',
      pages: 35,
      downloadUrl: '#',
      thumbnail: '🗺️',
      tags: ['mapas', 'história', 'geografia'],
      rating: 4.8,
      downloads: 145,
      dateAdded: '2026-01-12'
    },
    {
      id: 8,
      title: 'Vídeo - Sistema Solar',
      category: 'videos',
      subject: 'Ciências',
      description: 'Documentário sobre o sistema solar e planetas.',
      type: 'MP4',
      size: '89.3 MB',
      duration: '22:15',
      downloadUrl: '#',
      thumbnail: '🪐',
      tags: ['sistema solar', 'astronomia', 'planetas'],
      rating: 4.9,
      downloads: 267,
      dateAdded: '2026-01-28'
    }
  ];

  const filteredMaterials = materials.filter(material => {
    const matchesCategory = selectedCategory === 'all' || material.category === selectedCategory;
    const matchesSearch = material.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         material.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         material.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const getCategoryIcon = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.icon : '📚';
  };

  const formatFileSize = (size) => {
    return size;
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const stars = [];
    
    for (let i = 0; i < fullStars; i++) {
      stars.push('⭐');
    }
    if (hasHalfStar) {
      stars.push('⭐');
    }
    for (let i = stars.length; i < 5; i++) {
      stars.push('☆');
    }
    
    return stars.join('');
  };

  return (
    <div className="materiais-container">
      <div className="materiais-header">
        <h2>📋 Materiais Didáticos</h2>
        <p>Gerencie seus materiais e recursos pedagógicos</p>
      </div>

      <div className="controls-section">
        <div className="search-bar">
          <div className="search-input-wrapper">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              placeholder="Buscar materiais..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        <div className="view-controls">
          <div className="view-toggle">
            <button
              className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => setViewMode('grid')}
            >
              ⊞ Grade
            </button>
            <button
              className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
            >
              ☰ Lista
            </button>
          </div>
        </div>
      </div>

      <div className="categories-section">
        <div className="categories-header">
          <h3>Categorias</h3>
          <span className="total-count">{materials.length} materiais</span>
        </div>
        <div className="categories-grid">
          {categories.map(category => (
            <button
              key={category.id}
              className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.id)}
            >
              <div className="category-icon">{category.icon}</div>
              <div className="category-info">
                <h4>{category.label}</h4>
                <span className="category-count">{category.count} materiais</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="materials-section">
        <div className="materials-header">
          <h3>Materiais Disponíveis</h3>
          <span className="results-count">{filteredMaterials.length} resultados</span>
        </div>

        <div className={`materials-${viewMode}`}>
          {filteredMaterials.map(material => (
            <div key={material.id} className="material-card">
              <div className="material-thumbnail">
                <span className="material-icon">{material.thumbnail}</span>
              </div>
              
              <div className="material-content">
                <div className="material-header">
                  <h4>{material.title}</h4>
                  <span className="material-type">{material.type}</span>
                </div>
                
                <p className="material-description">{material.description}</p>
                
                <div className="material-meta">
                  <span className="material-subject">📚 {material.subject}</span>
                  <span className="material-size">📁 {formatFileSize(material.size)}</span>
                  {material.pages && <span className="material-pages">📄 {material.pages} páginas</span>}
                  {material.duration && <span className="material-duration">⏱️ {material.duration}</span>}
                  {material.levels && <span className="material-levels">🎮 {material.levels} níveis</span>}
                </div>
                
                <div className="material-tags">
                  {material.tags.map((tag, index) => (
                    <span key={index} className="tag">#{tag}</span>
                  ))}
                </div>
                
                <div className="material-stats">
                  <div className="rating">
                    <span className="stars">{renderStars(material.rating)}</span>
                    <span className="rating-number">{material.rating}</span>
                  </div>
                  <div className="downloads">
                    <span className="downloads-icon">⬇️</span>
                    <span className="downloads-number">{material.downloads}</span>
                  </div>
                  <span className="date-added">📅 {material.dateAdded}</span>
                </div>
                
                <div className="material-actions">
                  <button className="action-btn primary">
                    📥 Baixar
                  </button>
                  <button className="action-btn secondary">
                    👁️ Visualizar
                  </button>
                  <button className="action-btn tertiary">
                    ⭐ Favoritar
                  </button>
                  <button className="action-btn quaternary">
                    📤 Compartilhar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredMaterials.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">🔍</div>
            <h3>Nenhum material encontrado</h3>
            <p>Tente ajustar os filtros ou o termo de busca</p>
          </div>
        )}
      </div>

      <div className="upload-section">
        <div className="upload-card">
          <h3>📤 Adicionar Novo Material</h3>
          <p>Compartilhe seus materiais didáticos com outros professores</p>
          <div className="upload-area">
            <div className="upload-icon">📁</div>
            <p>Arraste arquivos aqui ou clique para selecionar</p>
            <button className="upload-btn">Selecionar Arquivos</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MateriaisDidaticos;
